import { Form, Input, Select } from "antd";
import { FC } from "react";
import { capitalize } from "~/utils";
import { PaymentTerms, RateType } from "~/utils/constants";

type Props = {};

export const TabRates: FC<Props> = () => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-6">Client Rates</h2>

      <div className="space-y-6">
        {/* Client Type & Rate Category */}
        <div className="p-4 border rounded-lg bg-gray-50">
          <h3 className="font-medium mb-4">Client Category</h3>
          <div className="grid grid-cols-2 gap-4">
            <Form.Item
              name="rateType"
              label="Rate Type"
            >
              <Select
                placeholder="Select rate type"
                options={Object.values(RateType).map((rate) => ({
                  label: capitalize(rate),
                  value: rate,
                }))}
              />
            </Form.Item>
            <Form.Item
              name="paymentTerms"
              label="Payment Terms"
            >
              <Select
                placeholder="Select payment terms"
                options={Object.values(PaymentTerms).map((term) => ({
                  label: capitalize(term),
                  value: term,
                }))}
              />
            </Form.Item>
          </div>
        </div>

      </div>
    </div>
  );
};
